var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/engine-user-agent.js
// module id = 149
// module chunks = 0